var map = {
	"./Step1.svg": 1025,
	"./Step2.svg": 1026,
	"./Step3.svg": 1027,
	"./calendar_1week.svg": 1537,
	"./calendar_2weeks.svg": 1538,
	"./calendar_date.svg": 1539,
	"./calendar_hour.svg": 1540,
	"./calendar_month.svg": 1541,
	"./calendar_question.svg": 1542,
	"./continue_brief.svg": 1012,
	"./copy_brief.svg": 1011,
	"./new_brief.svg": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1536;